import * as React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../redux/actions';
import '../../css/Modals.scss';
import { resetReduxModals } from '../../utilities/helpers';

// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
}
// local state
interface IState {
    features: any[]; 
}

class ActivityFactorCalculator extends React.Component<IProps, IState> {
  public state: IState = {
    features: [
        { name: "Pool Surface Baseline", factor: 1.0, qty: 1 },
        { name: "Water Curtain", factor: 0.1, qty: 0 },
        { name: "Waterfall", factor: 0.2, qty: 0 },
        { name: "40 sq.ft. Ground Jets", factor: 0.2, qty: 0 },
        { name: "15’ Water Cannon", factor: 0.5, qty: 0 },
        { name: "25’ Water Cannon", factor: 1.0, qty: 0 },
        { name: "Slide Plunge Zone No Raft", factor: 0.3, qty: 0 },
        { name: "Slide Plunge Zone w/Raft", factor: 0.8, qty: 0 },
        { name: "5’ Umbrella/Mushroom", factor: 0.7, qty: 0 },
        { name: "10’ Umbrella/Mushroom", factor: 1.0, qty: 0 },
        { name: "3’ Tipping Bucket", factor: 0.3, qty: 0 },
        { name: "5’ Tipping Bucket", factor: 0.8, qty: 0 },
        { name: "10’ Spray Loop", factor: 0.6, qty: 0 },
        { name: "15’ Spray Loop", factor: 1.0, qty: 0 },
      ]
  }

  async componentDidMount() {}
  //Check for user response to ActivityFactorCalculator modal.
  async componentDidUpdate(prevProps: IProps, prevState: IState) {
    const modal = this.props.reduxModals;

    //If modal was open but is now closed, check what user's response was.
    if (prevProps.reduxModals.showModal !== modal.showModal && modal.showModal === false) {
        resetReduxModals();
    }
  }
  handleQtyChange = (index:any, value:any) => {
    if (value < 0){
        return;
    }
    const newFeatures = [...this.state.features];
    newFeatures[index].qty = Number(value);
    this.setState({ features: newFeatures });
  };

  calculateEstimate = () => {
    return this.state.features.reduce(
      (sum:any, f:any) => sum + f.qty * f.factor,
      0
    ).toFixed(1);
  };
  public render() {
    return (
        <div className="pool-modal-container">
            <p className="pool-modal-table-par">
                Moving up from a baseline of 1.0, enter the quantity of each applicable
                pool feature from the list below to estimate the activity factor for a pool.
            </p>

            <table className = "pool-modal-table">
            <thead>
                <tr className="pool-modal-table-row">
                <th className="pool-modal-table-header-first">Qty</th>
                <th className="pool-modal-table-header-second">Activity Factor Add</th>
                <th className="pool-modal-table-header">Spray Feature</th>
                </tr>
            </thead>
            <tbody>
                {this.state.features.map((f:any, index:any) => (
                <tr key={index} className="pool-modal-input-row">
                    <td>
                    <input className="pool-modal-input-textbox"
                        disabled={index === 0 ? true : false}
                        type="number"
                        min="0"
                        value={f.qty}
                        onChange={(e) =>
                            this.handleQtyChange(index, e.target.value)
                        }
                    />
                    </td>
                    <td className="pool-modal-factor">{f.factor}</td>
                    <td>{f.name}</td>
                </tr>
                ))}
            </tbody>
            </table>

            <div
            style={{
                marginTop: "15px",
                fontWeight: "bold",
                borderTop: "2px solid black",
                paddingTop: "10px",
            }}
            >
            Activity Factor Estimate: {this.calculateEstimate()}
            </div>
        

            <div className="button-container">
                <div className="proj-create-btn" onClick={() => this.userResponse('cancel')}>
                    Close
                </div>
            </div>
        </div>
    );
  }


  private userResponse(response: string) {
    let modalResponse = {
        response:response
    }
    //This will trigger ModalContainer.tsx to hide all modals
    this.props.updateRedux('UPDATE_MODALS', { showModal: false, userResponse: modalResponse});
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxModals: state.reduxModals
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ActivityFactorCalculator);

